import type { IntlShape } from 'react-intl';

import { ASSIGN_TO_OPTIONS } from './components/NewAEG/newAegRequest/constants';
import {
    type AegApprovalTypeEnum,
    type AegServiceTypeEnum,
    AegStatusEnum,
    type AegVehicleTypeEnum,
} from '../../models/newAEG';

export {
    AegApprovalTypeEnum,
    AegAssignToEnum,
    AegAttendanceConditionEnum,
    AegBodyBuilderNameEnum,
    AegImplementOrBodyBuilderEnum,
    AegRepairScopeEnum,
    AegRequestTypeEnum,
    AegServiceTypeEnum,
    AegStatusEnum,
    AegVehicleTypeEnum,
} from '../../models/newAEG';

export type StageKey = 'abertura' | 'pendente' | 'pre' | 'analise' | 'corrigir' | 'reprovado' | 'creditado';

export type AegEnumGroup =
    | 'status'
    | 'requestType'
    | 'approvalType'
    | 'vehicleType'
    | 'serviceType'
    | 'repairScope'
    | 'attendanceCondition'
    | 'implementOrBodyBuilder'
    | 'bodyBuilderName';

export const AEG_STATUS_BY_STAGE: Record<StageKey, AegStatusEnum> = {
    abertura: AegStatusEnum.REQUEST_OPENING,
    pendente: AegStatusEnum.PENDING_ANALYSIS,
    pre: AegStatusEnum.PRE_APPROVAL,
    analise: AegStatusEnum.WARRANTY_ANALYSIS,
    corrigir: AegStatusEnum.CORRECT,
    reprovado: AegStatusEnum.REJECTED,
    creditado: AegStatusEnum.CREDITED,
};

export const AEG_STAGE_BY_STATUS: Record<AegStatusEnum, StageKey> = {
    [AegStatusEnum.REQUEST_OPENING]: 'abertura',
    [AegStatusEnum.PENDING_ANALYSIS]: 'pendente',
    [AegStatusEnum.PRE_APPROVAL]: 'pre',
    [AegStatusEnum.WARRANTY_ANALYSIS]: 'analise',
    [AegStatusEnum.CORRECT]: 'corrigir',
    [AegStatusEnum.REJECTED]: 'reprovado',
    [AegStatusEnum.CREDITED]: 'creditado',
};

export const AEG_NEXT_STAGES: Record<StageKey, StageKey[]> = {
    abertura: ['pendente'],
    pendente: ['pre', 'reprovado'],
    pre: ['analise', 'reprovado'],
    analise: ['corrigir', 'creditado', 'reprovado'],
    corrigir: ['pendente', 'reprovado'],
    reprovado: [],
    creditado: [],
};

export const formatAegEnum = (intl: IntlShape, group: AegEnumGroup, value?: string | null) =>
    value ? intl.formatMessage({ id: `intl-msg:support.aeg.${group}.${value}` }) : '';

export const formatAegStage = (intl: IntlShape, stage: StageKey) =>
    formatAegEnum(intl, 'status', AEG_STATUS_BY_STAGE[stage]);

export const getAegAssignToOptions = (intl: IntlShape) =>
    ASSIGN_TO_OPTIONS.map(option => ({ value: option.id, label: intl.formatMessage({ id: option.labelId }) }));

export const formatAegAssignTo = (intl: IntlShape, value?: string | null) =>
    getAegAssignToOptions(intl).find(option => option.value === value)?.label ?? value ?? '';

export type Request = {
    id: string;
    aegNumber: string;
    client: string;
    model: string;
    plate: string;
    chassis: string;
    approval: AegApprovalTypeEnum | '';
    value: number;
    owner: string;
    assignedTo: string;
    stage: StageKey;
    dealer: string;
    date: string;
    regional: string;
    vehicleType: AegVehicleTypeEnum | '';
    serviceType: AegServiceTypeEnum | '';
    sg: string;
    repairDate: string;
    stageTime: string;
    saleDate: string;
    km: number;
    warrantyType: string;
};
